<chitin-form-input
  class="col-auto"
  color="secondary"
  [size]="size()"
  [value]="dateRange()?.presetDisplayValue ?? dateRangeFormatted() ?? placeholder()"
  (valueChange)="checkClearValue($event)"
  icon="fa-solid fa-calendar-alt"
  [isDisabled]="isDisabled()"
  [ngbPopover]="daterangePickerPopover"
  placement="bottom-left"
  #pickerPopover="ngbPopover"
  triggers="manual"
  (focused)="pickerPopover.open()"
  (clicked)="pickerPopover.open()"
  [autoClose]="'outside'"
  popoverClass="pickerPopover"
  [container]="$any(appendTo())"
/>
<ng-template #daterangePickerPopover>
  <div class="popover-body">
    <div class="modal-body">
      <app-daterange-picker
        class="col-auto"
        [(dateRange)]="dateRange"
        [dateFormat]="dateFormat()"
        [minDate]="minDate()"
        [maxDate]="maxDate()"
      />
    </div>
  </div>
</ng-template>
